module.exports = { apiServer: 'https://ns-api.win.eventizer.hk', AdminServer: 'https://ns-admin.win.eventizer.hk', PayUrl: '/PG/pay/PAYMENT_TYPE/IS/ORDER_ID', RnpUrl: '/PG/pay/PAYMENT_TYPE/ISRNP/ORDER_ID' };
